import { render, staticRenderFns } from "./SalaEstudos.vue?vue&type=template&id=371ed169&scoped=true"
import script from "./SalaEstudos.vue?vue&type=script&lang=js"
export * from "./SalaEstudos.vue?vue&type=script&lang=js"
import style0 from "./SalaEstudos.vue?vue&type=style&index=0&id=371ed169&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ed169",
  null
  
)

export default component.exports